import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import useRequestConfig from './useRequestConfig';
import { getAPI } from '../../services/API';
import { isDebugModeSelector } from '../../redux/reducers/app/initialization';
import { DEFAULT_QUERY_PARAMS } from './constants';
import { sdkErrorHandler } from '../../utils';

export const QUERY_KEY_CATEGORY = 'category';
export const QUERY_KEY_CATEGORIES = 'categories';

export const useQueryCategories = (query = {}, queryOptions = {}) => {
  const requestConfig = useRequestConfig();
  const isDebugMode = useSelector(isDebugModeSelector);

  const queryParams = {
    status: isDebugMode ? 'ACTIVE,DEBUG' : 'ACTIVE',
    ...DEFAULT_QUERY_PARAMS,
    ...query,
  };

  const fetch = ({ signal }) =>
    getAPI()
      .categories.getAll({
        query: queryParams,
        signal,
        ...requestConfig,
      })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          queryOptions,
          query: queryParams,
          source: 'API SDK categories.getAll',
        })
      );

  return useQuery(
    [QUERY_KEY_CATEGORIES, queryParams, requestConfig.headers],
    fetch,
    queryOptions
  );
};

export const useQueryCategory = (categoryId, queryOptions = {}) => {
  const requestConfig = useRequestConfig();

  const fetch = ({ signal }) =>
    getAPI()
      .categories.getOne(categoryId, { signal, ...requestConfig })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          categoryId,
          queryOptions,
          source: 'API SDK categories.getOne',
        })
      );

  return useQuery(
    [QUERY_KEY_CATEGORY, categoryId, requestConfig.headers],
    fetch,
    queryOptions
  );
};
